import { createApiAsyncThunk } from '@/services/apiService'

const MACRO_PROCESS_URL = 'macro_processes'
const PROCESS_TEMPLATES_URL = 'process_templates'

export const fetchTemplatesForPurpose = createApiAsyncThunk(
  'macroProcessCreation/fetchTemplates',
  async (purpose, { api, rejectWithValue }) => {
    try {
      const response = await api
        .url(PROCESS_TEMPLATES_URL)
        .query({ purpose })
        .get()
      return response
    } catch (error) {
      return rejectWithValue(error.message || 'Erreur lors du chargement des templates')
    }
  }
)

export const createMacroProcess = createApiAsyncThunk(
  'macroProcessCreation/create',
  async (data, { api, rejectWithValue }) => {
    try {
      const response = await api
        .url(MACRO_PROCESS_URL)
        .post({ macro_process: data })
      return response
    } catch (error) {
      return rejectWithValue(error.data || { message: error.message, errors: {} })
    }
  }
)

export const fetchMacroProcesses = createApiAsyncThunk(
  'macroProcessCreation/fetchExisting',
  async (params = {}, { api, rejectWithValue }) => {
    try {
      const response = await api
        .url(MACRO_PROCESS_URL)
        .query(params)
        .get()
      return response
    } catch (error) {
      return rejectWithValue(error.message || 'Erreur lors du chargement des process existants')
    }
  }
)
